import React, { useEffect, useState } from "react";
import { FaEdit, FaPlus, FaTrash } from "react-icons/fa";

function ImageUploader({ images, setImages }) {
  const baseUrl = process.env.REACT_APP_API_URL;
  const [imageList, setImageList] = useState([]);

  useEffect(() => {
    if (!images) return setImageList([]);

    let parsedImages = [];

    if (typeof images === "string") {
      try {
        parsedImages = JSON.parse(images);
      } catch (error) {
        console.error("Error parsing images:", error);
      }
    } else if (Array.isArray(images)) {
      parsedImages = images;
    }

    setImageList(
      parsedImages.map((img) =>
        typeof img === "string"
          ? { url: img.startsWith("http") ? img : `${baseUrl}/uploads/${img}`, isFile: false }
          : { file: img, isFile: true }
      )
    );
  }, [images, baseUrl]);

  const handleAddImages = (e) => {
    const files = Array.from(e.target.files);
    const newImages = files.map((file) => ({ file, isFile: true }));
    const updatedImages = [...imageList, ...newImages];

    setImageList(updatedImages);
    setImages(updatedImages.map((img) => (img.isFile ? img.file : img.url))); // Send both new files & old URLs
  };

  const handleReplaceImage = (index) => (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const updatedImages = [...imageList];
    updatedImages[index] = { file, isFile: true };

    setImageList(updatedImages);
    setImages(updatedImages.map((img) => (img.isFile ? img.file : img.url)));
  };

  const handleRemoveImage = (index) => {
    const updatedImages = imageList.filter((_, i) => i !== index);
    setImageList(updatedImages);
    setImages(updatedImages.map((img) => (img.isFile ? img.file : img.url)));
  };

  return (
    <div>
      <label className="btn btn-primary">
        <FaPlus /> Add Images
        <input
          type="file"
          multiple
          hidden
          onChange={handleAddImages}
          accept="image/*"
        />
      </label>

      <div className="mt-3 d-flex flex-wrap">
        {imageList.map((image, index) => {
          const imageUrl = image.isFile ? URL.createObjectURL(image.file) : image.url;

          return (
            <div key={index} className="position-relative me-2">
              <img
                src={imageUrl}
                alt={`preview-${index}`}
                style={{ width: "100px", height: "100px", objectFit: "cover" }}
              />
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={handleReplaceImage(index)}
                id={`replace-${index}`}
              />
              <label
                htmlFor={`replace-${index}`}
                className="btn btn-sm btn-warning position-absolute top-0 start-0"
              >
                <FaEdit />
              </label>
              <button
                type="button"
                className="btn btn-sm btn-danger position-absolute top-0 end-0"
                onClick={() => handleRemoveImage(index)}
              >
                <FaTrash />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ImageUploader;

